export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHECK_TOKEN = "CHECK_TOKEN";
export const VALIDATE = "VALIDATE";
export const SET_COMPANY = "SET_COMPANY";
export const GET_LOGINS = "GET_LOGINS";
export const SET_AUTH_STATE = "SET_AUTH_STATE";

export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const GET_USERS = "GET_USERS";

export const CREATE_BILLING = "CREATE_BILLING";
export const UPDATE_BILLING = "UPDATE_BILLING";
export const GET_BILLINGS = "GET_BILLINGS";

export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";

export const SELECT_WELL = "SELECT_WELL";
export const ADD_TREATMENT_WELL = "ADD_TREATMENT_WELL";
export const DELETE_TREATMENT_WELL = "DELETE_TREATMENT_WELL";
export const UPDATE_TREATMENT_WELL = "UPDATE_TREATMENT_WELL";
export const SET_OFFSET_WELLS = "SET_OFFSET_WELLS";
export const ADD_OFFSET_WELL = "ADD_OFFSET_WELL";
export const DELETE_OFFSET_WELL = "DELETE_OFFSET_WELL";
export const UPDATE_OFFSET_WELL = "UPDATE_OFFSET_WELL";
export const SET_MAP = "SET_MAP";
export const SET_BOUNDING_BOX = "SET_BOUNDING_BOX";
export const SET_FILTER = "SET_FILTER";
export const SET_LOADING = "SET_LOADING";
export const CLEAR_FPZ = "CLEAR_FPZ";
export const SET_CARTOFACT_WELLS = "SET_CARTOFACT_WELLS";
export const SET_DIRECTIONAL_SURVEYS = "SET_DIRECTIONAL_SURVEYS";
export const ADD_FPZ_RADIUS = "ADD_FPZ_RADIUS";
export const DELETE_FPZ_RADIUS = "DELETE_FPZ_RADIUS";
export const UPDATE_FPZ_RADIUS = "UPDATE_FPZ_RADIUS";
export const SET_MAP_CENTER = "SET_MAP_CENTER";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export const SET_FPZ_CONTACTS = "SET_FPZ_CONTACTS";
export const SET_REPORT_IMAGES = "SET_REPORT_IMAGES";
export const SET_CURRENT_FPZ_REPORT = "SET_CURRENT_FPZ_REPORT";
export const SET_SELECTED_TREATMENT_WELLS = "SET_SELECTED_TREATMENT_WELLS";
export const SET_OPERATOR = "SET_OPERATOR";
export const SET_COMPANY_IDS = "SET_COMPANY_IDS";
export const SET_COMPANIES = "SET_COMPANIES";